<template>
    <div style="position: relative;" v-if="isShowLocal">
        <!-- <card class="searchNext" shadow>
            <div style="text-align:left;line-height: 0;">
                <NextBar ref="topSearchBar" :isHidden_xl="isJD" @next-search="nextSearch"></NextBar>
            </div>
        </card> -->
        <div class="step1" style="text-align:left;line-height: 0;margin-top: 10px;">
                <NextBar ref="topSearchBar" :isHidden_xl="isJD" @next-search="nextSearch"></NextBar>
        </div>
        <Tabs type="card" id="mainTabs" :value="value1" size="small" style="margin:5px;">
            <TabPane class="step2" name="1" :index=1 :label="region.country+'（'+headerTotal.country+'）'">
                <div>
                    <div class="demo-spin-container">
                        <SearchResult ref="country_search_rlt" @onPageChange="pageChange" @selectUpload-checked="countryTableRowChecked"></SearchResult>
                        <ResultTag class="step3" v-if="!isJD&&!isJXT" ref="country_search_Tag" :sTreeData="tagData" :isShowupLoadGroup=true :isShowTag=false :isCountryVersion=false :sTreeIndustry="sTreeIndustry" :isLocalNew=true @on-show-checkbox="showCountryChkBox" @clean-checked="clearCountryCheckList" @on-submit-checked="onCountrySubmitChecked" @on-tips-close="tagGeneralTipsClose" @on-one-key-upload="onCountryOneKeyUpload" @show-local-upload="slu3"></ResultTag>
                        <Row>
                            <Col span="12">
                            </Col>
                            <Col span="4">
                            </Col>
                        </Row>
                    </div>
                </div>
            </TabPane>
            <TabPane v-if="isProvinceShow" name="2" :index=2 :label="region.province.label+'（'+headerTotal.province+'）'">
                <div>
                    <div class="demo-spin-container">
                        <SearchResult ref="province_search_rlt" @onPageChange="pageChange" @selectUpload-checked="provinceTableRowChecked"></SearchResult>
                        <ResultTag v-if="!isJD&&!isJXT" ref="provice_search_Tag" :sTreeData="tagData" :isShowupLoadGroup=true :isShowTag=false :isCountryVersion=false :sTreeIndustry="sTreeIndustry" :isLocalNew=true @on-show-checkbox="showProvinceChkBox" @clean-checked="clearProvinceCheckList" @on-submit-checked="onProvinceSubmitChecked" @on-tips-close="tagGeneralTipsClose" @on-one-key-upload="onProvinceOneKeyUpload" @show-local-upload="slu2"></ResultTag>
                        <Row>
                            <Col span="12">
                            </Col>
                            <Col span="4">
                            </Col>
                        </Row>
                    </div>
                </div>
            </TabPane>
            <TabPane v-if="isCityShow" name="3" :index=3 :label="region.city!==undefined?region.city.label+'（'+headerTotal.city+'）':''">
                <div>
                    <div class="demo-spin-container">
                        <SearchResult ref="city_search_rlt" @onPageChange="pageChange" @selectUpload-checked="cityTableRowChecked"></SearchResult>
                        <ResultTag v-if="!isJD&&!isJXT" ref="city_search_Tag" :sTreeData="tagData" :isShowupLoadGroup=true :isShowTag=false :isCountryVersion=false :sTreeIndustry="sTreeIndustry" :isLocalNew=true @on-show-checkbox="showChkBox" @clean-checked="clearCheckList" @on-submit-checked="onGeneralSubmitChecked" @on-tips-close="tagGeneralTipsClose" @on-one-key-upload="onCityOneKeyUpload" @show-local-upload="slu1"></ResultTag>
                        <Row>
                            <Col span="12">
                            </Col>
                            <Col span="4">
                            </Col>
                        </Row>
                    </div>
                </div>
            </TabPane>
        </Tabs>
        <Spin fix v-if="spinShow3">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>数据加载中...</div>
        </Spin>
        <Modal v-model="isShowProgressBox" @on-ok="onProgressOK" @on-cancel="onProgressCancel" :mask-closable="false" :closable="false">
            <p slot="header" :style="{color:titletheme}" style="text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{uploadTitle}}</span>
            </p>
            <div><Progress :percent="uploadpercent" :stroke-width="20" status="active" text-inside /></div>
            <div slot="footer">
                <Button :type="buttonTheme" :disabled="isActiveButton" size="large" @click="onProgressOK">{{progressBoxButtonText}}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import tableresult from '../../common/common_engine/resulttable.vue'
import testData2 from '../../../assets/json/testTableData2.json'
// import TreeTag from '../../common/tree-select.vue'
import ResultTag from '../../common/common_engine/resultTag.vue'
import nextSearchBar from '../../common/common_engine/nextSearchBar.vue'
import nextSerachBar2 from '../../common/common_engine/nextSearchBar2.vue'
import treeIndustryData from '../../../assets/json/selected-tree-industry.json'
import treeTradeData from '../../../assets/json/selected-tree-trade.json'
import TagCityData from '../../../assets/json/tagCity.json'
import More from "../../../api/common/more.js"
import ConstJson from "../../../api/common/constjson.js"
import store from "../../../store"
let MoreFun = new More()
let constJ = new ConstJson()
export default {
    name: "CityTable",
    // props:{
    //   tRegion:Object,
    // },
    inject: ["reload", "getSliders", "parentSearchParams"],
    data() {
        return {
            scencs:'',//scencs=''政策，scencs='answer'解答
            timeZone: '',
            value1: "0",
            region: {
                city: { label: "", value: "" },
                province: { label: "", value: "" },
                country: "中央",
                classid: "",
            },
            headerTotal: {
                city: 0,
                province: 0,
                country: 0,
            },
            spinShow1: false,
            spinShow2: false,
            spinShow3: false,
            isCityShow: true,
            isProvinceShow: true,
            flag: true,
            tagData: {}, //this.getTreeData(),
            sTreeIndustry: this.getIndustryData(0),
            //streeProvince: this.getProvince(),
            nextSearchParameter: {
                timeZone: [],
                text2: "",
                index: 1,
                fileforce: {}
            },
            city: {
                timeZone: [],
                text2: "",
                index: 1,
                fileforce: {}
            },
            province: {
                timeZone: [],
                text2: "",
                index: 1,
                fileforce: {}
            },
            country: {
                timeZone: [],
                text2: "",
                index: 1,
                fileforce: {}
            },
            isShowNext: false,
            currentTag: {},
            sliders: this.getSliders(),
            isShowLocal: true,
            defaultpc: {
                p: "510100",
                c: "000000",
            },
            defaultTagpc: [],
            isShowProgressBox: false, //上传对话框
            uploadpercent: 0, //上传进度
            isPollingStop: false, //暂停轮询
            uploadTitle: '稍候片刻,请静待上传完成', //提示信息
            titletheme: '#2d8cf0', //提示信息颜色
            errorStatus: '', //错误状态
            progressBoxButtonText: '确定', //确定按钮文字
            isActiveButton: true, //是否禁用按钮
            buttonTheme: 'success', //按钮样式
            disconnectTimes: 0, //网络连接失败，20次后进度条按钮可以关闭
            isfilter: false,
            isFirstSerach: true,
            isJD:false,//解答不显示一键上传
            isJXT:store.state.user.isjxt,//isjxt=true则不显示一键上传
        }
    },
    mounted() {
        // this.$nextTick(function() {
        //     this.initStep()
        //     //console.log('citytable,mounted...')
        //     //this.cityNextSearch(this.city, this.province, this.country)
        // })


        // console.log(this.tRegion)
        // this.region=this.tRegion
        //this.region=this.tRegion
    },
    created() {
        console.log('citytable->created===========>')
        //console.log(this.parentSearchParams)
        //console.log(this.$router.history.current.name)
        this.isJD=this.$router.history.current.name==='jdsearch'?true:false
        if (this.parentSearchParams.city && this.parentSearchParams.province) {
            let defaultCityData = {
                city: this.parentSearchParams.city,
                province: {
                    value: this.parentSearchParams.province.value,
                    label: this.parentSearchParams.province.label,
                },
                classid: this.parentSearchParams.classid,
                country: "中央",
            }
            this.getRegion(defaultCityData)

        }


        //this.autoSelectTab()
        this.value1 = "1"
        // this.region.classid = this.$route.query.classid
        // console.log(this.$route.query.city)
        // this.region.province=this.$route.query.city
        // this.region.city=this.$route.query.city[1]

        //this.selectedClassid=this.$route.query.classid
        //this.countryNextSearch()
        //this.cityNextSearch()
    },
    methods: {
        
        jd_CitySelected(value,scencs){
            // console.log('jd_CitySelected====>')
            this.getRegion(value,scencs)
        },
        autoSelectTab() {
            console.log('autoSelectTab=======>')
            console.log(this.headerTotal)
            this.$nextTick(() => {
                if (this.headerTotal.country > 0) {
                    this.value1 = "1"
                } else if (this.headerTotal.province > 0) {
                    this.value1 = "2"
                } else if (this.headerTotal.city > 0) {
                    this.value1 = "3"
                } else {
                    this.value1 = "1"
                }
            })
        },
        goUpload(src) {
            if (src === "city") {
                if (this.headerTotal.city > 0) {
                    this.showDialog2("提示", "", this.headerTotal.city, 'city')
                } else {
                    this.$Message.warning('无有效数据')
                    return
                }
            } else if (src === "province") {
                if (this.headerTotal.province > 0) {
                    this.showDialog2("提示", "", this.headerTotal.province, 'province')
                } else {
                    this.$Message.warning('无有效数据')
                    return
                }
            } else if (src === "country") {
                if (this.headerTotal.country > 0) {
                    this.showDialog2("提示", "", this.headerTotal.country, 'country')
                } else {
                    this.$Message.warning('无有效数据')
                    return
                }
            }
        },
        slu1() {
            console.log('slu1')
            this.goUpload('city')
            //this.showDialog2("提示", "", this.headerTotal.city, 'city')

        },
        slu2() {
            console.log('slu2')
            this.goUpload('province')
            //this.showDialog2("提示", "", this.headerTotal.province, 'province')

        },
        slu3() {
            console.log('slu3')
            this.goUpload('country')
            //this.showDialog2("提示", "", this.headerTotal.country, 'country')

        },
        onProgressOK() {
            this.isPollingStop = true
            this.isShowProgressBox = false
        },
        onProgressCancel() {

        },
        getOneKeyUploadProgress(id) {
            console.log("request progress id:" + id)
            constJ.reqGetOneKey_UploadProgress_V2(id).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        let total = res.item.total
                        let complete = res.item.complete
                        let per = 0
                        if (total > 0) {
                            per = parseInt((complete / total) * 100)
                        } else {
                            this.$Message.error("总计上传条数为零");
                            return
                        }
                        this.uploadpercent = per
                    } else {
                        this.$Message.error(res.rltdesc);
                        this.isShowProgressBox = false
                        this.isPollingStop = true
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    this.isShowProgressBox = false
                    this.isPollingStop = true
                    return
                }
            }).catch(error => {
                if (!error.response) {
                    // network error
                    //this.errorStatus = 'Error: Network Error';

                    // this.isShowProgressBox = false
                    // this.isPollingStop = true
                    if (this.disconnectTimes <= 20) {
                        this.disconnectTimes++;
                    } else {
                        this.uploadTitle = "您的网络连接异常,请勿担心,系统仍然会持续完成文件上传任务"
                        this.titletheme = "#ff9900"
                        this.buttonTheme = 'warning'
                        this.isActiveButton = false
                    }
                    this.$Message.error("网络连接异常");
                } else {
                    this.errorStatus = error.response.data.message;
                    this.isShowProgressBox = false
                    this.isPollingStop = true
                    this.$Message.error(this.errorStatus);
                }
                //console.log( this.errorStatus)
            })
        },
        autoPollingOneKeyProgress(id) {
            //状态初始化
            this.uploadpercent = 0
            this.isPollingStop = false
            this.uploadTitle = "稍候片刻,请静待上传完成"
            this.titletheme = "#2d8cf0"
            this.isActiveButton = true
            this.buttonTheme = "success"
            this.disconnectTimes = 0
            // this.progressBoxButtonText="关闭进度显示"
            let clock = window.setInterval(() => {
                this.getOneKeyUploadProgress(id)
                if (this.uploadpercent === 100 || this.isPollingStop) {
                    this.uploadTitle = "文件上传成功,谢谢您的耐心等待"
                    this.titletheme = "#19be6b"
                    this.isActiveButton = false
                    this.buttonTheme = "success"
                    //this.progressBoxButtonText="确定"
                    console.log("clearInterval...")
                    window.clearInterval(clock)
                }
            }, 1000)
        },
        pageChange(index, tabName) {
            console.log("pageChange,index:" + index + ",tabName:" + tabName)
            //this.isfilter=false
            if (tabName === "city") {
                this.city.index = index
                this.cityNextSearch(this.city, this.province, this.country)
            } else if (tabName === "province") {
                this.province.index = index
                this.cityNextSearch(this.city, this.province, this.country)
            } else if (tabName === "country") {
                this.country.index = index
                this.cityNextSearch(this.city, this.province, this.country)
            }
        },
        cityTableRowChecked(listCount) {
            this.$refs.city_search_Tag.showBtnTxt(listCount)
        },
        provinceTableRowChecked(listCount) {
            this.$refs.provice_search_Tag.showBtnTxt(listCount)
        },
        countryTableRowChecked(listCount) {
            this.$refs.country_search_Tag.showBtnTxt(listCount)
        },
        tableRowChecked(listCount) {
            //this.$refs.generalTag.showBtnTxt(listCount)
        },
        onGeneralSubmitChecked(folderid) {
            // //提交General数据用户已选择的文件
            let count = this.$refs.city_search_rlt.showListTotal()
            let checked = this.$refs.city_search_rlt.getDocIdChecked()
            if (checked.length > 0) {
                this.upLoadFileToCloud(checked, folderid)
            } else {
                this.$Message.warning("没有选择文件")
            }
            this.clearCheckList()
            //还原searchbar为显示状态
            this.isShowSearchBar = true
        },
        onProvinceSubmitChecked(folderid) {
            let count = this.$refs.province_search_rlt.showListTotal()
            let checked = this.$refs.province_search_rlt.getDocIdChecked()
            if (checked.length > 0) {
                this.upLoadFileToCloud(checked, folderid)
            } else {
                this.$Message.warning("没有选择文件")
            }
            this.clearProvinceCheckList()
            //还原searchbar为显示状态
            this.isShowSearchBar = true
        },
        onCountrySubmitChecked(folderid) {
            let count = this.$refs.country_search_rlt.showListTotal()
            let checked = this.$refs.country_search_rlt.getDocIdChecked()
            if (checked.length > 0) {
                this.upLoadFileToCloud(checked, folderid)
            } else {
                this.$Message.warning("没有选择文件")
            }
            this.clearCountryCheckList()
            //还原searchbar为显示状态
            this.isShowSearchBar = true
        },

        clearCheckList() {
            this.$refs.city_search_rlt.clearChkList()
        },
        clearProvinceCheckList() {
            this.$refs.province_search_rlt.clearChkList()
        },
        clearCountryCheckList() {
            this.$refs.country_search_rlt.clearChkList()
        },
        upLoadFileToCloud(idList, folderid) {
            constJ.upLoadFileToCloud(idList, folderid).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.$Message.success("已上传" + idList.length + "个文件至云端")
                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {})
        },
        showChkBox(value) {
            this.$refs.city_search_rlt.showCheckBox(value)
        },
        showProvinceChkBox(value) {
            this.$refs.province_search_rlt.showCheckBox(value)
        },
        showCountryChkBox(value) {
            this.$refs.country_search_rlt.showCheckBox(value)
        },
        getIndustryData(node) {
            if (node === 0) {
                node = { "data": [{ "label": "进出口税收管理类", "id": "001" }] }
            }
            // this.sTreeIndustry=node
            // return treeIndustryData
            return node
        },
        getProvince() {
            return TagCityData
        },
        // getTableData() {
        //   return testData2
        // },

        getTreeData() {
            return treeTradeData
        },
        getIndustryData() {
            return treeIndustryData
        },
        clearRegion() {
            this.region.country = ''
            this.region.city = {}
            this.region.province = {}
            //this.region.classid = ""
            this.currentTag = {}
            // this.nextSearchParameter.timeZone = []
            // this.nextSearchParameter.text2 = ''
            this.defaultTagpc = []


            // this.city={} 
            // this.province={}
            // this.country={}

        },
        //点击左侧树时重置用户操作产生的参数
        clearLastNewParms() {
            //重置地方版最新列表用户操作产生的参数
            // this.city.timeZone=[]
            // this.city.text2=''
            this.city.index = 1

            // this.province.timeZone=[]
            // this.province.text2=''
            this.province.index = 1

            // this.country.timeZone=[]
            // this.country.text2=''
            this.country.index = 1
        },
        getRegion(args,scencs='') {
            console.log('scencs='+scencs)
            this.scencs=scencs

            this.isFirstSerach = true
            this.isfilter = false
            this.clearRegion()
            this.clearLastNewParms()
            //获取二次查询参数
            this.getNextSearchParm()
            this.$nextTick(() => {
                //不清空二次查询条件的显示20210430
                //在点击切换城市列表的时候才清空二次检索条件
                // this.$refs.topSearchBar.resetCondition()
                this.region = args
                this.defaultpc.p = this.region.province.value
                this.defaultpc.c = this.region.city.value
                //console.log(this.region)
                // this.region.province = args.city[0]
                // this.region.city = args.city[1]
                // this.region.classid = args.classid
                //console.log(this.region)
                // this.region.country = args.country
                // this.region.classid = args.classid
                //this.region.city === undefined && this.region.city === null


                if (!this.region.city && !this.region.province ||
                    this.region.city.length === 0 && this.region.province.length === 0 ||
                    this.region.city.value === '' && this.region.province.value === '') {
                    this.isCityShow = false
                    this.isProvinceShow = false
                    this.cityNextSearch(this.city, this.province, this.country)
                    //this.value1 = "3"
                    //this.autoSelectTab()
                } else {

                    if (!this.region.province || this.region.province.length === 0 || this.region.province.value === '') {

                        this.isProvinceShow = false
                        this.cityNextSearch(this.city, this.province, this.country)
                        //this.value1 = "3"
                        //this.autoSelectTab()
                    } else {

                        this.isProvinceShow = true
                        this.cityNextSearch(this.city, this.province, this.country)
                        //this.value1 = "2"
                        //this.autoSelectTab()
                    }

                    if (!this.region.city || this.region.city.length === 0 || this.region.city.value === '') {
                        this.isCityShow = false
                        this.cityNextSearch(this.city, this.province, this.country)
                        //this.value1 = "2"
                        //this.autoSelectTab()
                    } else {
                        this.isCityShow = true
                        this.cityNextSearch(this.city, this.province, this.country)
                        //this.value1 = "1"
                        //this.autoSelectTab()
                    }



                }












                //this.buildDefaultTagpc()
            })

            // this.$nextTick(() => {
            //   //this.isShowLocal=true
            // })
            // return this.tRegion;
        },

        buildDefaultTagpc() {
            this.defaultTagpc = []
            let conuntry = {
                p: '000000',
                c: '000000'
            }
            let province = {}
            let city = {}
            this.defaultTagpc.push(conuntry)

            if (this.region.province) {
                province = {
                    p: this.region.province.value,
                    c: '000000'
                }
                this.defaultTagpc.push(province)

            }
            if (this.region.city && this.region.city.value) {
                city = {
                    p: this.region.province.value,
                    c: this.region.city.value
                }
                this.defaultTagpc.push(city)
            }
        },
        childTagChange(tag) {
            // console.log("childTagChange...")
            this.buildDefaultTagpc()
            this.isfilter = true
            this.currentTag = tag
            this.clearLastNewParms()
            this.cityNextSearch(this.city, this.province, this.country)
        },

        tagGeneralTipsClose() {
            this.$refs.generalTag.tipClose()
        },
        showDialog2(title, content, total, src) {
            let that = this
            this.$Modal.confirm({
                title: title,
                //content: '<p>' + content + '</p>',
                render: h => {
                    return h('span', [
                        '您确定上传此法规分类下的 ',
                        h('span', {
                            domProps: {
                                innerHTML: `<span style="font-weight:bold;color:red;font-size:16px;" >` + total + `</span> 个文件到<span style="color:#ff9900;font-size:14px;" > [智慧云端] </span>吗`,
                            }
                        }), '  ?'
                    ])
                },
                okText: '确认',
                cancelText: '取消',
                onOk: () => {
                    if (src === "city") {
                        this.$refs.city_search_Tag.PopFolderTreeV2(1)
                    }
                    if (src === "province") {
                        this.$refs.provice_search_Tag.PopFolderTreeV2(1)
                    }
                    if (src === "country") {
                        this.$refs.country_search_Tag.PopFolderTreeV2(1)
                    }

                    //this.PopFolderTree(1)
                },
                onCancel: () => {
                    return
                    // this.$Message.info('Clicked cancel');
                }
            });
        },

        //一键上传
        onGeneralOneKeyUpload() {

            // console.log("综合检索一键上传...")
            // console.log(this.formCommonSearch)
            // if (this.searchType === 1) {
            //   this.handle_OneKey_GeneralFiles(this.formCommonSearch, this.selectNode.complexNode.id)
            // } else if (this.searchType === 4) {
            //   this.handle_OneKey_InOutFiles(this.formCommonSearch, this.selectNode.tradeNode.id)
            // } else if (this.searchType === 5) {
            //   this.handle_OneKey_TaxBreakFiles(this.formCommonSearch, this.selectNode.taxBreakNode.id)
            // }

        },
        onCityOneKeyUpload(folderid) {
            console.log("folderid:" + folderid)
            //this.isfilter = true
            let args1 = {
                ntext: this.nextSearchParameter.text2,
                ntime: this.nextSearchParameter.timeZone,
                potence: this.nextSearchParameter.fileforce.id,
                classid: this.region.classid,
                tagid: this.currentTag.id,
                //region: this.region.city,
                ps: this.defaultpc,
                tagpc: [{
                    p: this.region.province.value,
                    c: this.region.city.value
                }],
                folderid: folderid,
                fs: this.isFirstSerach,
                ft: true,
            }
            //console.log(args1)
            this.handle_OneKey_CityFiles(args1)
        },
        onProvinceOneKeyUpload(folderid) {
            console.log("folderid:" + folderid)
            //this.isfilter = true
            let args2 = {
                ntext: this.nextSearchParameter.text2,
                ntime: this.nextSearchParameter.timeZone,
                potence: this.nextSearchParameter.fileforce.id,
                classid: this.region.classid,
                tagid: this.currentTag.id,
                //region: this.region.city,
                ps: this.defaultpc,
                tagpc: [{
                    p: this.region.province.value,
                    c: '000000'
                }],
                folderid: folderid,
                fs: this.isFirstSerach,
                ft: true,
            }
            //console.log(args2)
            this.handle_OneKey_CityFiles(args2)
        },
        onCountryOneKeyUpload(folderid) {
            console.log("folderid:" + folderid)
            //this.isfilter = true
            let args3 = {
                ntext: this.nextSearchParameter.text2,
                ntime: this.nextSearchParameter.timeZone,
                potence: this.nextSearchParameter.fileforce.id,
                classid: this.region.classid,
                tagid: this.currentTag.id,
                //region: this.region.city,
                ps: this.defaultpc,
                tagpc: [{
                    p: '000000',
                    c: '000000'
                }],
                folderid: folderid,
                fs: this.isFirstSerach,
                ft: true,
            }
            //console.log(args3)
            this.handle_OneKey_CityFiles(args3)
        },
        //二次查询的时间参数是否为空
        //为空返回true,不为空返回false
        isTimeNullOrEmpty(value) {
            let rlt = false
            console.log(value)
            if (value.time.length === 0 && value.text === "") {
                rlt = true
            } else if (value.time.length === 2 && value.time[0] === "" && value.time[1] === "" && value.text === "") {
                rlt = true
            }
            console.log(rlt)
            return rlt
        },
        //获取二次查询框的检索参数
        getNextSearchParm() {
            if (this.$refs.topSearchBar) {
                let v = this.$refs.topSearchBar.getSearchCondition()
                this.nextSearchParameter.timeZone = v.time
                this.nextSearchParameter.text2 = v.text
                this.nextSearchParameter.fileforce = v.fileforce
            }

        },
        nextSearch(value) {
            console.log("nextSearch===========>")
            this.currentTag = {}

            // if (this.isTimeNullOrEmpty(value)) {
            //     this.isFirstSerach = true
            // } else {
            //     this.isFirstSerach = false
            // }

            this.isfilter = false
            this.nextSearchParameter.timeZone = value.time
            this.nextSearchParameter.text2 = value.text
            this.nextSearchParameter.fileforce = value.fileforce

            this.clearLastNewParms()

            this.cityNextSearch(this.city, this.province, this.country, this.nextSearchParameter)
        },
        //p=city,p1=province,p2=countrywide
        cityNextSearch(p, p1, p2, ns) {
            //console.log(this.currentTag.id)
            // console.log('p, p1, p2, ns==>')
            // console.log(p, p1, p2, ns)
            if (!ns) {
                ns = this.nextSearchParameter
            }
            var id = this.region.classid
            let tagid = this.currentTag.id === undefined ? "" : this.currentTag.id
            this.handle_getNewFiles(id, this.region, tagid, p, p1, p2, ns)

        },
        // provinceSearch(value) {
        //     this.value1 = "2"
        //     this.province.timeZone = value.time
        //     this.province.text = value.text
        //     this.cityNextSearch(this.city, this.province, this.country)
        // },

        provinceNextSearch(index, nextParams) {

            //this.value1 = "2"
            //this.autoSelectTab()
            this.spinShow2 = true
            let pageIndex = index === undefined ? 1 : index
            var id = this.region.classid
            let tagid = this.currentTag.id === undefined ? "" : this.currentTag.id
            if (nextParams === undefined) {
                //this.getProvinceFiles(pageIndex, id, this.region, tagid)
            } else {
                //this.getProvinceFiles(pageIndex, id, this.region, tagid, nextParams.time, nextParams.text)
            }
        },
        // countrySearch(value) {
        //     this.value1 = "3"
        //     this.country.timeZone = value.time
        //     this.country.text = value.text
        //     this.cityNextSearch(this.city, this.province, this.country)
        // },

        countryNextSearch(index, nextParams) {
            //this.value1 = "3"
            //this.autoSelectTab()

            this.spinShow2 = true
            let pageIndex = index === undefined ? 1 : index
            var id = this.region.classid
            let tagid = this.currentTag.id === undefined ? "" : this.currentTag.id
            if (nextParams === undefined) {
                //this.getProvinceFiles(pageIndex, id, this.region, tagid)
            } else {
                //this.getProvinceFiles(pageIndex, id, this.region, tagid, nextParams.time, nextParams.text)
            }
        },
        // countryNextSearch() {
        //   this.value1 = "3"
        //   this.spinShow3 = true
        //   var that = this
        //   setTimeout(function() {
        //     that.spinShow3 = false
        //   }, 1000)
        // },
        laodTable() {

        },
        onTagChange() {
            //this.cityNextSearch()
        },
        //获取最新地方版文件,默认加载地市,省,全国文件
        handle_getNewFiles(classid, region, tagid, parameter, parameter2, parameter3, ns) {
            console.log('handle_get_local_newfiles...')
            //var id = classid
            var args = {}
            args.classid = classid
            args.tagid = tagid
            args.region = region
            args.p = parameter
            args.p1 = parameter2
            args.p2 = parameter3
            args.ns = ns
            args.isfilter = this.isfilter
            args.fs = this.isFirstSerach
            args.tagpc = this.defaultTagpc
            args.scencs=this.scencs
            //console.log(args)
            constJ.reqGetLocalLastFiles(args).then(res => {
                console.log(res)
                var city = null
                var province = null
                var countrywide = null
                if (res.tbls.length > 0) {
                    for (let i = 0; i < res.tbls.length; i++) {
                        if (res.tbls[i].tblname === "tbl_city") {
                            city = {
                                header: testData2.header,
                                tabrows: res.tbls[i].items,
                                total: res.tbls[i].total,
                                classid: classid,
                                tabname: "city",
                                warninglevel: res.tbls[0].warninglevel,
                                warningtext: res.tbls[0].warningtext,
                                protect: res.tbls[0].protect,
                                //tags: res.tbls[i].classifytag,
                                //tagstatus: { minback: res.tbls[i].minback, minlock: res.tbls[i].minlock },
                                isjd:this.scencs==='answer'?true:false,
                                index: res.tbls[i].pageindex,
                                showColumns:this.scencs===''?(classid.startsWith('000007000002') || tagid.startsWith('000007000002') ? MoreFun.getColumns().treaty : []):MoreFun.getColumns().jd
                            }
                        }

                        if (res.tbls[i].tblname === "tbl_provice") {
                            province = {
                                header: testData2.header,
                                tabrows: res.tbls[i].items,
                                total: res.tbls[i].total,
                                classid: classid,
                                tabname: "province",
                                warninglevel: res.tbls[0].warninglevel,
                                warningtext: res.tbls[0].warningtext,
                                protect: res.tbls[0].protect,
                                isjd:this.scencs==='answer'?true:false,
                                //tags: res.tbls[i].classifytag,
                                //tagstatus: { minback: res.tbls[i].minback, minlock: res.tbls[i].minlock },
                                index: res.tbls[i].pageindex,
                                showColumns:this.scencs===''?(classid.startsWith('000007000002') || tagid.startsWith('000007000002') ? MoreFun.getColumns().treaty : []):MoreFun.getColumns().jd
                            }
                        }

                        if (res.tbls[i].tblname === "tbl_global") {
                            countrywide = {
                                header: testData2.header,
                                tabrows: res.tbls[i].items,
                                total: res.tbls[i].total,
                                classid: classid,
                                tabname: "country",
                                warninglevel: res.tbls[0].warninglevel,
                                warningtext: res.tbls[0].warningtext,
                                protect: res.tbls[0].protect,
                                isjd:this.scencs==='answer'?true:false,
                                tags: res.tbls[i].classifytag,
                                tagstatus: { minback: res.tbls[i].minback, minlock: res.tbls[i].minlock },
                                index: res.tbls[i].pageindex,
                                showColumns:this.scencs===''?(classid.startsWith('000007000002') || tagid.startsWith('000007000002') ? MoreFun.getColumns().treaty : []):MoreFun.getColumns().jd
                            }
                        }


                    }

                } else {
                    //默认
                    city = {
                        header: testData2.header,
                        tabrows: null,
                        total: 0,
                        classid: classid,
                        tabname: "city",
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        isjd:this.scencs==='answer'?true:false,
                        //tags: res.tbls[0].classifytag,
                        //tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: res.tbls[0].pageindex,
                        showColumns: [],
                    }

                    province = {
                        header: testData2.header,
                        tabrows: null,
                        total: 0,
                        classid: classid,
                        tabname: "province",
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        isjd:this.scencs==='answer'?true:false,
                        //tags: res.tbls[0].classifytag,
                        //tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: res.tbls[0].pageindex,
                        showColumns: [],
                    }

                    countrywide = {
                        header: testData2.header,
                        tabrows: null,
                        total: 0,
                        classid: classid,
                        tabname: "country",
                        warninglevel: res.tbls[0].warninglevel,
                        warningtext: res.tbls[0].warningtext,
                        protect: res.tbls[0].protect,
                        isjd:this.scencs==='answer'?true:false,
                        //tags: res.tbls[0].classifytag,
                        //tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
                        index: res.tbls[0].pageindex,
                        showColumns: [],
                    }
                }
                console.log('isCityShow:' + this.isCityShow)
                console.log('isProvinceShow:' + this.isProvinceShow)
                //console.log('isCityShow:' + this.isCityShow)
                this.$refs.topSearchBar.display(true)
                if (this.isCityShow) {
                    //绑定city
                    //console.log(city)
                    this.$refs.city_search_rlt.show(city)
                    //绑定二次搜索框
                    //this.$refs.cityNextSearchBar.display(false)

                    //绑定province
                    this.$refs.province_search_rlt.show(province)
                    //绑定二次搜索框
                    //this.$refs.provinceNextSearchBar.display(false)

                    //绑定countrywide
                    this.$refs.country_search_rlt.show(countrywide)
                    //绑定二次搜索框
                    //this.$refs.countryNextSearchBar.display(false)
                } else if (this.isProvinceShow) {
                    console.log('show province..')
                    console.log(province)
                    //绑定province
                    this.$refs.province_search_rlt.show(province)
                    //绑定二次搜索框
                    //this.$refs.provinceNextSearchBar.display(false)

                    //绑定countrywide
                    this.$refs.country_search_rlt.show(countrywide)
                    //绑定二次搜索框
                    //this.$refs.countryNextSearchBar.display(false)
                } else {
                    this.$refs.country_search_rlt.show(countrywide)
                }


                //绑定header total
                this.headerTotal.city = city.total
                this.headerTotal.province = province.total
                this.headerTotal.country = countrywide.total
                //绑定tag
                var _obj = MoreFun.getTag(countrywide.tags)
                var tempTag = {
                    tags: _obj,
                    status: countrywide.tagstatus,
                    warninglevel: countrywide.warninglevel,
                    warningtext: countrywide.warningtext,
                    protect: countrywide.protect,
                }
                console.log('local new tagdata================================================================>')
                console.log(this.tagData)
                this.tagData = tempTag

                //是否在法规界面显示和绑定tag,2021.04.12
                this.flag = true
                this.$refs.generalTag.setTagLevels(region)
                //this.flag = false
                //this.$refs.generalTag.setTagLevels(region)

                //set tab
                this.autoSelectTab()

            }).catch(err => {})
        },
        // getProvinceFiles(currentIndex, classid, region, tagid, timeZone, text) {
        //     console.log('getProvinceFiles...')
        //     //var id = classid
        //     var args = {}
        //     args.size = 10
        //     args.index = currentIndex
        //     args.classid = classid
        //     args.tagid = tagid
        //     args.timezone = timeZone
        //     args.text = text
        //     args.region = region
        //     //console.log('args:',args)
        //     constJ.reqGetLocalProvinceFiles(args).then(res => {
        //         //console.log("reqGetLasFiles..."+"id:"+id+",tagid:"+tagid)
        //         console.log(res)
        //         var obj = null
        //         if (res.tbls.length > 0) {
        //             obj = {
        //                 header: testData2.header,
        //                 tabrows: res.tbls[0].items,
        //                 total: res.tbls[0].total,
        //                 classid: classid,
        //                 tabname: "province",
        //                 //tags: res.tbls[0].classifytag,
        //                 //tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
        //                 index: res.tbls[0].pageindex,
        //                 showColumns: classid.startsWith('000007000002') || tagid.startsWith('000007000002') ? MoreFun.getColumns().treaty : []
        //             }
        //         } else {
        //             //默认
        //             obj = {
        //                 header: testData2.header,
        //                 tabrows: null,
        //                 total: 0,
        //                 classid: classid,
        //                 tabname: "province",
        //                 //tags: res.tbls[0].classifytag,
        //                 //tagstatus: { minback: res.tbls[0].minback, minlock: res.tbls[0].minlock },
        //                 index: res.tbls[0].pageindex,
        //                 showColumns: [],
        //             }
        //         }

        //         //绑定列表
        //         this.$refs.province_search_rlt.show(obj)
        //         //绑定二次搜索框
        //         //this.$refs.provinceNextSearchBar.display(true)
        //         //绑定tag
        //         // var _obj = MoreFun.getTag(obj.tags)
        //         // var tempTag = {
        //         //   tags: _obj,
        //         //   status: obj.tagstatus,
        //         // }
        //         // this.tagData = tempTag

        //         this.flag = true
        //         this.$refs.generalTag.setTagLevels(region)
        //     }).catch(err => {})
        // },
        //城市一键上传
        handle_OneKey_CityFiles(args) {
            constJ.reqOneKeyLocalUpload_V2(args).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        //this.$Message.success("城市一键上传成功")
                        //启动定时器
                        if (res.uploadidentity !== undefined && res.uploadidentity !== "") {
                            this.isShowProgressBox = true
                            this.autoPollingOneKeyProgress(res.uploadidentity)
                        } else {
                            this.$Message.error("无效的identity");
                            return
                        }

                    } else {
                        this.$Message.error(res.rltdesc);
                        return
                    }
                } else {
                    this.$Message.error(res.rtndesc);
                    return
                }
            }).catch(function(err) {})
        },
        //省级文件一键上传
        // handle_OneKey_ProvinceFiles(args, tagid) {
        //     var item = {}
        //     item.text = args.content
        //     item.stime = args.da[0]
        //     item.etime = args.da[1]
        //     item.potence = args.fileforce.id
        //     item.tagid = tagid
        //     item.text2 = args.text2
        //     constJ.reqOneKeyProvinceFiles(item).then(res => {
        //         console.log(res)
        //         if (res.rtncode === 1) {
        //             if (res.rltcode === 1) {
        //                 this.$Message.success("省级文件一键上传成功")
        //             } else {
        //                 this.$Message.error(res.rltdesc);
        //                 return
        //             }
        //         } else {
        //             this.$Message.error(res.rtndesc);
        //             return
        //         }
        //     }).catch(function(err) {})
        // },
        //全国文件一键上传
        //     handle_OneKey_CountryFiles(args, tagid) {
        //         var item = {}
        //         item.text = args.content
        //         item.stime = args.da[0]
        //         item.etime = args.da[1]
        //         item.potence = args.fileforce.id
        //         item.tagid = tagid
        //         item.text2 = args.text2
        //         constJ.reqOneKeyCountryFiles(item).then(res => {
        //             console.log(res)
        //             if (res.rtncode === 1) {
        //                 if (res.rltcode === 1) {
        //                     this.$Message.success("国家文件一键上传成功")
        //                 } else {
        //                     this.$Message.error(res.rltdesc);
        //                     return
        //                 }
        //             } else {
        //                 this.$Message.error(res.rtndesc);
        //                 return
        //             }
        //         }).catch(function(err) {})
        //     },
    },
    watch: {
        sliders: function(v) {
            console.log(this.$refs.city_search_rlt)
            var id = this.region.classid
            var tagid = this.currentTag.id === undefined ? "" : this.currentTag.id
            //多屏还原到单屏时判断id来动态显示或隐藏文号字段
            if (id.startsWith('000007000002') || tagid.startsWith('000007000002')) {
                //如果只选择了省，则城市可能是空对象
                //console.log('didididi===================>1')
                if (this.$refs.city_search_rlt) {
                    this.$refs.city_search_rlt.onSlidersChanged(MoreFun.getColumns().treaty)
                    this.$refs.province_search_rlt.onSlidersChanged(MoreFun.getColumns().treaty)
                    this.$refs.country_search_rlt.onSlidersChanged(MoreFun.getColumns().treaty)
                } else if (this.$refs.province_search_rlt) {
                    this.$refs.province_search_rlt.onSlidersChanged(MoreFun.getColumns().treaty)
                    this.$refs.country_search_rlt.onSlidersChanged(MoreFun.getColumns().treaty)
                } else {
                    this.$refs.country_search_rlt.onSlidersChanged(MoreFun.getColumns().treaty)
                }

            } else {
                //console.log('didididi===================>2')
                //如果只选择了省，则城市可能是空对象
                //如果是解答数据需要重新渲染header
                if (this.$refs.city_search_rlt) {
                    this.$refs.city_search_rlt.onSlidersChanged(this.scencs==='answer'?MoreFun.getColumns().jd:null)
                    this.$refs.province_search_rlt.onSlidersChanged(this.scencs==='answer'?MoreFun.getColumns().jd:null)
                    this.$refs.country_search_rlt.onSlidersChanged(this.scencs==='answer'?MoreFun.getColumns().jd:null)
                } else if (this.$refs.province_search_rlt) {
                    this.$refs.province_search_rlt.onSlidersChanged(this.scencs==='answer'?MoreFun.getColumns().jd:null)
                    this.$refs.country_search_rlt.onSlidersChanged(this.scencs==='answer'?MoreFun.getColumns().jd:null)
                } else {
                    this.$refs.country_search_rlt.onSlidersChanged(this.scencs==='answer'?MoreFun.getColumns().jd:null)
                }

            }
        }
    },
    components: {
        'SearchResult': tableresult,
        'ResultTag': ResultTag,
        // 'NextBar': nextSearchBar,
        'NextBar': nextSerachBar2
    },
}
</script>
<style lang="less" scoped>
.demo-spin-container {
    display: inherit;
    width: auto;
    height: auto;
    position: relative;

    /* border: 1px solid #eee;*/
}

.common-width {
    width: 250px;
}


/*spin style*/
.demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
    from {
        transform: rotate(0deg);
    }

    50% {
        transform: rotate(180deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.demo-spin-col {
    height: 100px;
    position: relative;
    border: 1px solid #eee;
}

.searchNext {
    margin-bottom: 5px;
    background-color: #fff;

}

.searchNext/deep/.ivu-card-body {
    padding: 5px;
}

.commonTag {
    padding: 5px;
    margin: 5px;
    border: 1px solid #dcdee2;
}

//tab bar的下划线
#mainTabs/deep/.ivu-tabs-bar {
    margin-bottom: 5px;
    //border:0px;  //tab bar的下划线
}

</style>
